// extracted by mini-css-extract-plugin
export default {"wrapper":"Skeleton_wrapper__Mic7X","pulse":"Skeleton_pulse__UE1eQ","wrapper-2":"Skeleton_wrapper-2__LSPak","pulse-black":"Skeleton_pulse-black__ADiee"};